  <div class="main_form">
    <div class="the_card">

      <mat-accordion>
          <mat-expansion-panel hideToggle #example2 [(expanded)]="isExpanded" class="mat-elevation-z10" >
              <mat-expansion-panel-header class="mat-expan">
                <mat-panel-title class="controller">
                <h3 class="title"> Basic Information </h3>
                </mat-panel-title>
                <em class="ti-arrow-circle-down" style="font-size: 2.5rem;" *ngIf="!example2.expanded"></em> 
                <em class="ti-arrow-circle-right" style="font-size: 2.5rem;" *ngIf="example2.expanded"></em> 


              </mat-expansion-panel-header>
              <form [formGroup]="adrprogressForm">
                <div class="forms_value">
                  <div class="contain" >
                    <div class="the_input">
                      <span for="">Suit Number</span>
                      <p class="information">{{selectedSuitProgresss?.SuitNo}}</p>
                    </div>
          
                    <div class="the_input">
                      <span for="">Parties</span>
                      <p class="information">{{selectedSuitProgresss?.PartyA}}</p>
                    </div>
          
                    <div class="the_input">
                      <span for="">Claim Type</span>
                      <p class="information">{{getClaimType(selectedSuitProgresss?.ClaimTypeId).ClaimTypeName}}</p>
                    </div>
          
                    <div class="the_input">
                      <span for="">claim</span>
                      <div id="bodydesc" style="margin-left:0; margin-right:auto; width:250px; height: 60px; overflow-y: scroll;">

                        <p class="information">
                
                          {{selectedSuitProgresss?.Claims}}
                
                        </p>
                
                </div>
                      <!-- <p class="information p">{{selectedSuitProgresss?.Claims}}</p> -->
                    </div>
                  </div>
          
                  <div class="contain">
                    <div class="the_input">
                      <span for="">Year of Suit</span>
                      <p class="information">{{getSuitYear(selectedSuitProgresss?.YearOfSuitId).YearOfSuitName}}</p>
                    </div>
          
                    <div class="the_input">
                      <span for="">VS</span>
                      <p class="information">{{selectedSuitProgresss?.PartyB}}</p>
                    </div>
                    <div class="the_input">
                      <span for="">Lorp</span>
                      <p class="information">{{getLorp(selectedSuitProgresss?.LorpId).LorpName}}</p>
                    </div>
                    <div class="the_input">
                      <span for="">Claim Amount</span>
                      <p class="information">{{selectedSuitProgresss?.ClaimAmount}}</p>
                    </div>
                    <div class="the_input">
                      <span for="">Currency</span>
                      <p class="information">{{getCurrency(selectedSuitProgresss?.CurrencyId).CurrencyName}}</p>
                    </div>
          
                  </div>
          
                  <div class="contain">
                    <div class="the_input">
                      <span for="">Defence</span>
                      <p class="information">{{selectedSuitProgresss?.Defence}}</p>
                    </div>
                    <div class="the_input">
                      <span for="">State</span>
                      <p class="information">{{selectedSuitProgresss?.StateId}}</p>
                    </div>
                    <div class="the_input">
                      <span for="">Location</span>
                      <p class="information">{{selectedSuitProgresss?.Location}}</p>
                    </div>
          
                    <!-- <button class="default_primary-button">Save</button> -->
                  </div>
                </div>
              </form>
              <mat-action-row>
                  <!-- <button mat-button (click)="onAction(event)">Action1</button> -->
              </mat-action-row>
          </mat-expansion-panel>

          <mat-expansion-panel hideToggle #example1 [(expanded)]="isExpanded2" class="mat-elevation-z10" >
            <mat-expansion-panel-header class="mat-expan">
              <mat-panel-title class="controller">
              <h3 class="title"> Report Progress </h3>
              </mat-panel-title>
              <em class="ti-arrow-circle-down" style="font-size: 2.5rem;" *ngIf="!example1.expanded"></em> 
              <em class="ti-arrow-circle-right" style="font-size: 2.5rem;" *ngIf="example1.expanded"></em> 

            </mat-expansion-panel-header>
            <cradua-suitprogress
            [selectedSuitProgresss]="selectedSuitProgresss"
            (emitSave)="onEmitSuitSubmit($event)"
            ></cradua-suitprogress>
            <mat-action-row>
                <!-- <button mat-button (click)="onAction(event)">Action1</button> -->
            </mat-action-row>
          </mat-expansion-panel>
        <div class="other_contents">
          <mat-tab-group color="accent" style="margin-bottom: 5rem;">
                                                                    
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="example-tab-icon">landscape</mat-icon>
                ADR Counsel
              </ng-template>
      
            <cradua-adrcounsel
            [counseltypes]="counseltypes"
            [selectedSuitProgresss]="selectedSuitProgresss"
            ></cradua-adrcounsel>
      
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">landscape</mat-icon>
                  Assets in Dispute
                </ng-template>
        
              <cradua-assetsindispute
              [selectedSuitProgresss]="selectedSuitProgresss"
              ></cradua-assetsindispute>
        
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">map</mat-icon>
                  ADR Documents
                </ng-template>
                <!-- [selectedLandTitle]="selectedLandTitle" -->
              <cradua-document
              [selectedSuitProgresss]="selectedSuitProgresss"
              [documentTypeCodes]="documenttypecodes"
              [documentTypes]="documenttypes"
              [securityClassifications]="securityclassifications"
              [fileLocations]="filelocations"
              [fetchDocuments]="fetchDocuments"
              [isLoadingDocument]="isLoadingDocument"
              [progress]="progress"
              [error]="error"
              [isInProgress]="isInProgress"
              [isReady]="isReady"
              [hasFailed]="hasFailed"
              (emitUpload)="onUploadFile($event)"
              (emitSaveManyDoc)="onSaveManyDoc($event)"
              (emitCancel)="onCancelUpload($event)"
              (emitReset)="onResetUpload($event)"
              ></cradua-document>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <mat-icon class="example-tab-icon">landscape</mat-icon>
                  ADR Personel
                </ng-template>
        
              <cradua-adrpersonnel
              [communitiess]="communitiess"
              [selectedSuitProgresss]="selectedSuitProgresss"
              ></cradua-adrpersonnel>
        
              </mat-tab>
        </mat-tab-group>
        </div>
      </mat-accordion>
     
    </div>
    

    
  </div>


